import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { environment } from 'src/environments/environment';
import { BusinessModuleRoutes } from './business/business.route';
import { AccountActivationComponent } from './layout/account-activation/account-activation.component';
import { AdminResetPasswordComponent } from './layout/admin-reset-password/admin-reset-password.component';
import { ForgotPasswordComponent } from './layout/forgot-password/forgot-password.component';
import { VerifyOtpComponent } from './layout/verify-otp/verify-otp.component';
import { LayoutDefaultComponent } from './layout/layout-default/layout-default.component';
import { LayoutHomeComponent } from './layout/layout-home/layout-home.component';
import { LoginComponent } from './layout/login/login.component';
import { MobileBypassComponent } from './layout/mobile-bypass/mobile-bypass.component';
import { ResetPasswordComponent } from './layout/reset-password/reset-password.component';
import { DeactivateGuardService } from './layout/services/deactivate-guard.service';
import { AuthGuardService } from './layout/services/auth-guard.service';
import { SignupComponent } from './layout/signup/signup.component';
import { OnDemandPreloadStrategy } from './preload/on-demand-preload-strategy';

const routes: Routes = [
  {
    path: '',
    component: LayoutHomeComponent,
    children: [
      { path: '', redirectTo: 'login', pathMatch: 'full' },
      {
        path: 'login',
        component: LoginComponent,
        canActivate: [DeactivateGuardService],
      },
      {
        path: 'mobile/:userName/:userType/:token',
        component: MobileBypassComponent,
      },
      {
        path: 'signup',
        component: SignupComponent,
        canActivate: [DeactivateGuardService],
      },
      {
        path: 'forgot-password',
        component: ForgotPasswordComponent,
        canActivate: [DeactivateGuardService],
      },
      {
        path: 'verify-otp',
        component: VerifyOtpComponent,
        canActivate: [DeactivateGuardService],
      },
      {
        path: 'account-activation',
        component: AccountActivationComponent,
        canActivate: [DeactivateGuardService],
      },
      {
        path: 'reset-password',
        component: ResetPasswordComponent,
        canActivate: [DeactivateGuardService],
      },
      {
        path: 'admin-reset-password',
        component: AdminResetPasswordComponent,
        canActivate: [DeactivateGuardService],
      }
    ],
  },
  {
    path: 'app',
    component: LayoutDefaultComponent,
    canActivate: [AuthGuardService],
    runGuardsAndResolvers: 'always',
    children: [
      {
        path: 'landing',
        loadChildren: () =>
          import('./routes/landing/landing.module').then(
            (m) => m.LandingModule
          ),
      },
      {
        path: 'settings',
        loadChildren: () =>
          import('./routes/user-setting/user-setting.module').then(
            (m) => m.UserSettingModule
          ),
      },
      ...BusinessModuleRoutes
    ],
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: environment.useHash,
      onSameUrlNavigation: 'reload',
      preloadingStrategy: OnDemandPreloadStrategy,
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
